import { UserTypeOptions } from '../constants';
var isVisitor = function (cookies) {
    return Reflect.has(cookies, '_ga');
};
var getVisitorType = function (cookies, isLoggedIn) {
    if (isLoggedIn) {
        return UserTypeOptions.Member;
    }
    if (isVisitor(cookies)) {
        return UserTypeOptions.Visitor;
    }
    return UserTypeOptions.NewVisitor;
};
export { getVisitorType };
